module.exports = __webpack_public_path__ + "img/kronii.bd09b7d8.png";